<template>
    <v-edit-dialog :return-value.sync="form.state" cancel-text="취소" save-text="변경" v-on="{ save }" large eager persistent>
        <slot />
        <template #input>
            <v-select v-model="form.state" v-bind="{ ...attrs_input, items }" class="mt-3" />
            <v-fade-transition>
                <v-overlay v-show="loading" absolute light color="white">
                    <v-progress-circular indeterminate size="100" width="5" color="primary" />
                </v-overlay>
            </v-fade-transition>
        </template>
    </v-edit-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, INQUIRY_STATES } from "@/assets/variables";

const items = Object.values(INQUIRY_STATES);

export default {
    props: {
        value: { state: Object, default: () => ({}) },
    },
    data: () => ({
        loading: false,

        form: {},
        items,
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = JSON.parse(JSON.stringify(this.value));
        },
        async save() {
            if (this.loading) return;
            this.loading = true;

            try {
                let { _id, state } = this.form;
                let form = { _id, state };

                const { inquiry } = await api.console.inquiries.putState(form);

                this.$emit("updateItem", inquiry);
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
